import { useEffect } from "react";
import ModalComponent from "../../components/modals";
import LaddaButton from "../../components/buttons/laddaButton";
import FormTextField from "../../components/textField/formTextField";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import "./styles.css";

const MAX_COMMENT_LENGTH = 2000;

const validationSchema = yup.object().shape({
  comment: yup
    .string()
    .max(MAX_COMMENT_LENGTH, `Máximo ${MAX_COMMENT_LENGTH} caracteres`)
});

const DeleteTaskModal = ({ open, handleClose, task, onConfirm }) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { comment: "" }
  });

  useEffect(() => {
    if (!open) return;
    setValue("comment", "");
  }, [open, setValue]);

  const handleCloseModal = () => {
    reset();
    handleClose();
  };

  const onSubmit = (formData) => {
    const comment = formData.comment?.trim() || "";
    onConfirm?.({ comment });
    return;
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleCloseModal}
      title={"Eliminar tarea"}
      width={"600px"}
      actions={
        <div className="j-center w-complete">
          <LaddaButton
            width={"200px"}
            variant="contained"
            backgroundColor="white"
            color="#c95d42ff"
            borderColor="#c95d42ff"
            onClick={handleCloseModal}
            style={{ marginRight: "10px" }}
          >
            <div className="HContainer align-center">
              <p className="button_text">Cancelar</p>
            </div>
          </LaddaButton>
          <LaddaButton
            width={"200px"}
            variant="contained"
            color="white"
            backgroundColor="#c95d42ff"
            onClick={handleSubmit(onSubmit)}
          >
            <div className="HContainer align-center">
              <p className="button_text">Eliminar</p>
            </div>
          </LaddaButton>
        </div>
      }
    >
      <form>
        <div style={{ marginTop: 8 }}>
          {task?.description && (
            <p className="detail-label" style={{ marginBottom: 8 }}>
              <strong>Tarea:</strong> {task.description}
            </p>
          )}

          <p className="detail-label mt-10">
            Comentario de eliminación (opcional):
          </p>
          <FormTextField
            name="comment"
            control={control}
            isTextArea={true}
            error={errors.comment}
            maxLength={MAX_COMMENT_LENGTH}
            rows={5}
            margin={"0"}
            placeholder={`Agrega un comentario sobre la razón de eliminación (máx. ${MAX_COMMENT_LENGTH} caracteres)...`}
          />
          <p
            className="detail-helper"
            style={{ fontSize: 12, color: "#888", marginTop: 6 }}
          >
            Este comentario quedará registrado junto con la fecha de
            eliminación.
          </p>
        </div>
      </form>
    </ModalComponent>
  );
};

export default DeleteTaskModal;
